namespace Areas.Account.InspectionsSummary{
    "use strict";

    export function status(cellElement, cellInfo) {

        cellElement.html(cellInfo.data.statusLk);

        if (cellInfo.data.statusLk == 'Accepted') {
            $(cellElement).css('background-color', 'lightgreen');
        } else if (cellInfo.data.statusLk == 'Pending') {
            $(cellElement).css('background-color', 'gold');
        } else if (cellInfo.data.statusLk == 'ReInspected') {
            $(cellElement).css('background-color', 'pink');
        } else if (cellInfo.data.statusLk == 'Rejected') {
            $(cellElement).css('background-color', 'red');
        }

    }

    export function viewLink(cellElement, cellInfo) {
        var fieldData = cellInfo.data.inspectionId;
        var statusData = cellInfo.data.statusLk;
        var projectId = cellInfo.component.option("InspectionProjectId");
        var linkInfo = "";

        if (statusData == "Rejected") {
            linkInfo = "<a href= 'https://inspection.capnet.ucla.edu/Inspections/View/Index/" + String(fieldData) + "'>View</a> <br/><br/>" +
                "<a href= '#' onClick='Areas.Account.InspectionsSummary.createReinspection(" + String(fieldData) + ", " + projectId + ")'>ReInspection</a> <br/>"
            $(cellElement).css('background-color', 'orange')
        }
        else if (statusData == "Draft") {
            linkInfo = "<a href= 'https://inspection.capnet.ucla.edu/Inspections/Edit/Index/" + String(fieldData) + "'>Edit</a>"
        }
        else {
            linkInfo = "<a href= 'https://inspection.capnet.ucla.edu/Inspections/View/Index/" + String(fieldData) + "'>View</a>"
        }
        cellElement.html(linkInfo);
    }

    export function createReinspection(inspectionId: number, projectId: number) {
        sendRequest(`https://inspection.capnet.ucla.edu/Inspections/Create/ReInspection/${inspectionId}/${projectId}/`, "", "PUT");
    }

    export function goToActions(sharePointLink: string, projectInfoId: number) {
        return (e: any) => {
            if (e.value == 1) {
                goToSharePoint(sharePointLink);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }

    export function goToInspection(e: any) {
        const grid = $("#InspectionGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = row[0].inspectionId;
            let linkInfo = "https://inspection.capnet.ucla.edu/Inspections/View/Index/" + id;
            location.href = linkInfo;
        }
    }

    export function goToSharePoint(sharePointLink) {
        let linkInfo = "https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjects/" + sharePointLink + "/";
        if (sharePointLink != "") {
            window.open(linkInfo);
        }
        else {
            window.open("https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjectsList");
        }
    }

    export function goToPIFPAF(projectInfoId) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        if (projectInfoId != 0) {
            window.open(linkInfo);
        }

    }

}